"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var IntegerValidator_1 = require("../../core/model/data-dictionary/validators/IntegerValidator");

var NumberInRangeValidator_1 = require("../../core/model/data-dictionary/validators/NumberInRangeValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var index_1 = require("../../core/utils/index");
/**
 * Defines settings for release, so called matrix table, such as optimization goals settings, strategy settings,
 * constraints or rounding rules settings. Instance of settings is related to {@link PriceZone price zone},
 * {@link ProductCategory category} and {@link ProductSensitivity product sensitivity}.
 *
 * @author RV
 * @author Radek Beran (optional release-scoping)
 */


var Settings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Settings, _DomainObject_1$Domai);

  /**
   * Constructs settings instance.
   *
   * Note that if you add a constraint which affects the calculation of the optimal price please update
   * also a {@link ReleasePriceCalculationRules} class.
   *
   * @param id
   * @param title
   * @param priceZoneId
   * @param productCategoryId
   * @param productSensitivityId
   * @param releaseId id of release if this is release-related settings
   * @param competitorHistoryLength
   * @param competitorsPriorityId
   * @param constraintSettings
   * @param optimizationGoalsSettings
   * @param strategySettings
   */
  function Settings( // Add new fields also to withSettingsFrom and areEmptySettings!
  id, title, priceZoneId, productCategoryId, productSensitivityId, releaseId, competitorHistoryLength, competitorsPriorityId, constraintSettings, optimizationGoalsSettings, strategySettings) {
    var _this;

    _classCallCheck(this, Settings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Settings).call(this));
    _this.id = id;
    _this.title = title;
    _this.priceZoneId = priceZoneId;
    _this.productCategoryId = productCategoryId;
    _this.productSensitivityId = productSensitivityId;
    _this.releaseId = releaseId;
    _this.competitorHistoryLength = competitorHistoryLength;
    _this.competitorsPriorityId = competitorsPriorityId;
    _this.constraintSettings = constraintSettings;
    _this.optimizationGoalsSettings = optimizationGoalsSettings;
    _this.strategySettings = strategySettings;
    return _this;
  }
  /**
   * Returns copy of "this" object with settings copied from given parameter.
   * @param settings
   */


  _createClass(Settings, [{
    key: "withSettingsFrom",
    value: function withSettingsFrom(settings) {
      return this.copy('competitorHistoryLength', settings.competitorHistoryLength).copy('competitorsPriorityId', settings.competitorsPriorityId).copy('constraintSettings', settings.constraintSettings).copy('optimizationGoalsSettings', settings.optimizationGoalsSettings).copy('strategySettings', settings.strategySettings);
    }
  }, {
    key: "areEmptySettings",
    value: function areEmptySettings() {
      return index_1.Utils.isNull(this.competitorHistoryLength) && index_1.Utils.isNull(this.competitorsPriorityId) && (index_1.Utils.isNull(this.constraintSettings) || this.constraintSettings.areEmptySettings()) && index_1.Utils.isNull(this.optimizationGoalsSettings) && index_1.Utils.isNull(this.strategySettings);
    }
    /**
     * Removes fields that are inherited from resolvent and returns updated settings.
     * If a field is present and identical in resolvent, then remove it (set to null).
     *
     * @param resolvent
     * @returns settings updated settings (without inherited fields)
     */

  }, {
    key: "getDiffWithResolvent",
    value: function getDiffWithResolvent(resolvent) {
      var resultSettings = this;

      if (this.priceZoneId !== resolvent.priceZoneId || this.productCategoryId !== resolvent.productCategoryId || this.productSensitivityId !== resolvent.productSensitivityId || this.releaseId !== resolvent.releaseId) {
        throw new Error("Incompatible resolvent ".concat(resolvent.priceZoneId, ", ").concat(resolvent.productCategoryId, ", ").concat(resolvent.productSensitivityId, " "));
      }

      if (this.competitorHistoryLength && this.competitorHistoryLength === resolvent.competitorHistoryLength) {
        resultSettings = resultSettings.copy('competitorHistoryLength', null);
      }

      if (this.competitorsPriorityId && this.competitorsPriorityId === resolvent.competitorsPriorityId) {
        resultSettings = resultSettings.copy('competitorsPriorityId', null);
      }

      if (this.optimizationGoalsSettings) {
        resultSettings = resultSettings.copy('optimizationGoalsSettings', this.optimizationGoalsSettings.diffOptimizationGoalsSettingsWithResolvent(resolvent.optimizationGoalsSettings));
      }

      if (this.strategySettings) {
        resultSettings = resultSettings.copy('strategySettings', this.strategySettings.diffStrategyWithResolvent(resolvent.strategySettings));
      }

      if (resultSettings.constraintSettings) {
        var diffConstraints = resultSettings.constraintSettings.diffConstraintsWithResolvent(resolvent.constraintSettings);
        resultSettings = resultSettings.copy('constraintSettings', diffConstraints);
      }

      return resultSettings;
    }
  }]);

  return Settings;
}(DomainObject_1.DomainObject);

exports.Settings = Settings;

Settings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Settings.name);
  return {
    id: builder.id('id'),
    title: builder.opt(builder.str('title')),
    priceZoneId: builder.str('priceZoneId'),
    productCategoryId: builder.str('productCategoryId'),
    productSensitivityId: builder.str('productSensitivityId'),
    releaseId: builder.opt(builder.str('releaseId')),
    competitorHistoryLength: builder.opt(builder.num('competitorHistoryLength', new NumberInRangeValidator_1.NumberInRangeValidator(0, 105), new IntegerValidator_1.IntegerValidator())),
    competitorsPriorityId: builder.opt(builder.lookup('competitorsPriorityId', 'sequences/competitors-priorities')),
    constraintSettings: builder.opt(builder.lookup('constraintSettings', 'enums/constraint-types')),
    optimizationGoalsSettings: builder.opt(builder.lookup('optimizationGoalsSettings', 'enums/optimization-goal-types')),
    strategySettings: builder.opt(builder.lookup('strategySettings', 'enums/strategy-types'))
  };
}();